<div class="chat-loyalty" [class.chat-loyalty--locked]="locked">
  @if (showLabel) {
    <div class="chat-loyalty__label">
      Loyalty programme for {{ passengerName }}
      @if (isMandatory) {
        <span class="chat-loyalty__required" aria-hidden="true">*</span>
      }
    </div>
  }

  @if (locked && chosenSummary === 'Skipped') {
    <div class="chat-loyalty__chosen">{{ chosenSummary }}</div>
  }

  <div class="chat-loyalty__row">
    <label class="chat-loyalty__field-wrap">
      <span class="chat-loyalty__field-label">Airline</span>
      <input
        type="text"
        class="chat-loyalty__control"
        aria-label="Airline"
        [disabled]="locked"
        placeholder="Start typing an airline…"
        [(ngModel)]="airlineModel"
        (focus)="focus$.next($any($event.target).value)"
        [ngbTypeahead]="airline"
        (selectItem)="onAirlineSelected($event)"
        [resultTemplate]="airlinesTemplate"
        [inputFormatter]="formatterAirlines"
      />
      <ng-template #airlinesTemplate let-r="result"> {{ r.title }} ({{ r.value }}) </ng-template>
    </label>

    <label class="chat-loyalty__field-wrap">
      <span class="chat-loyalty__field-label">Loyalty number</span>
      <input
        type="text"
        aria-label="Loyalty number"
        [disabled]="locked"
        [(ngModel)]="loyaltyNumber"
        placeholder="e.g. 1234567"
      />
    </label>
  </div>

  <div class="chat-loyalty__actions">
    @if (!isMandatory) {
      <button type="button" class="chat-loyalty__skip" [disabled]="locked" (click)="onSkip()">
        Skip
      </button>
    }
    <button
      type="button"
      class="chat-loyalty__continue"
      [disabled]="locked || !isValid"
      (click)="onContinue()"
    >
      Continue
    </button>
  </div>
</div>
